import {
    COUNTRY_MESSAGES_RESET,
    RESET_COUNTRY_MESSAGES_SUCCESS,
    CREATE_COUNTRY_FAILED,
    CREATE_COUNTRY_REQUEST,
    CREATE_COUNTRY_SUCCESS,
    DELETE_COUNTRY_FAILED,
    DELETE_COUNTRY_REQUEST,
    DELETE_COUNTRY_SUCCESS,
    GET_COUNTRY_BY_NAME_FAILED,
    GET_COUNTRY_BY_NAME_REQUEST,
    GET_COUNTRY_BY_NAME_SUCCESS,
    GET_COUNTRY_FAILED,
    GET_COUNTRY_REQUEST,
    GET_COUNTRY_SUCCESS,
    UPDATE_COUNTRY_FAILED,
    UPDATE_COUNTRY_REQUEST,
    UPDATE_COUNTRY_SUCCESS,
  } from "./actionTypes"
  
  export const initialState = {
    loading: false,
    countriesData: [],
    success: "",
    error: "",
  }
  
  function reducer(state = initialState, action) {
    switch (action.type) {
      case GET_COUNTRY_REQUEST:
        return {
          ...state,
          success: "",
          error: "",
          loading: true,
        }
      case GET_COUNTRY_SUCCESS:
        const {data, ...filters} = action.payload
        return {
          ...state,
          countriesData: [...data],
          ...filters,
          loading: false,
          success: "GET",
        }
      case GET_COUNTRY_FAILED:
        return {
          ...state,
          error: action.payload.message,
          loading: false,
        }
      case GET_COUNTRY_BY_NAME_REQUEST:
        return {
          ...state,
          success: "",
          error: "",
          loading: true,
        }
      case GET_COUNTRY_BY_NAME_SUCCESS:
        return {
          ...state,
          countriesData: action.payload,
          loading: false,
          success: "SUCCESS",
        }
      case GET_COUNTRY_BY_NAME_FAILED:
        return {
          ...state,
          error: action.payload.message,
          loading: false,
        }
      case CREATE_COUNTRY_REQUEST:
        return {
          ...state,
          loading: true,
        }
      case CREATE_COUNTRY_SUCCESS:
        return {
          ...state,
          countriesData: [...state.countriesData, action.payload],
          success: "CREATE",
          loading: false,
        }
      case CREATE_COUNTRY_FAILED:
        return {
          ...state,
          error: "FAILED CREATE",
          loading: false,
        }
      case DELETE_COUNTRY_REQUEST:
        return {
          ...state,
          loading: true,
          success: "",
          error: "",
        }
      case DELETE_COUNTRY_SUCCESS:
        return {
          ...state,
          countriesData: state.countriesData.filter(
            country => country.id.toString() !== action.payload.toString()
          ),
          success: "DELETE",
          loading: false,
        }
      case DELETE_COUNTRY_FAILED:
        return {
          ...state,
          error: "FAILED DELETE",
          loading: false,
        }
      case UPDATE_COUNTRY_REQUEST:
        return {
          ...state,
          loading: true,
          success: "",
          error: "",
        }
      case UPDATE_COUNTRY_SUCCESS:
        return {
          ...state,
          countriesData: state.countriesData.map(country =>
            country.id.toString() === action.payload.id.toString()
              ? { country, ...action.payload }
              : country
          ),
          success: "UPDATE",
          loading: false,
        }
      case UPDATE_COUNTRY_FAILED:
        return {
          ...state,
          error: "FAILED UPDATE",
          loading: false,
        }
      case COUNTRY_MESSAGES_RESET:
        return {
          ...state,
          error: "",
          success: "",
          loading: false,
        }
        case RESET_COUNTRY_MESSAGES_SUCCESS:
          return {
            ...state,
            error: null,
            success: null
          }
      default:
        return state
    }
  }
  
  export default reducer
  
